import React from 'react';
import Header from '../components/Header';
import DigitalSignage from '../components/DigitalSignage';
import Footer from '../components/Footer';

const SignagePage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <div className="pt-20">
        <DigitalSignage />
      </div>
      <Footer />
    </div>
  );
};

export default SignagePage;
